export function cleanTwitterHandle(handle) {
  if (!handle) return handle;
  
  // Normalize Unicode characters (e.g. 𝐑𝐚𝐲𝐩𝐥𝐞 -> Rayple)
  let cleaned = String(handle).normalize('NFKC').trim();
  
  // Extract from URL if present
  const urlMatch = cleaned.match(/(?:twitter\.com|x\.com)\/([^/?#]+)/i);
  if (urlMatch && urlMatch[1]) {
    cleaned = urlMatch[1];
  }
  
  // Remove leading @ symbols
  cleaned = cleaned.replace(/^@+/, '');
  
  // Remove any remaining invalid characters (Twitter handles only allow alphanumeric and underscores)
  cleaned = cleaned.replace(/[^a-zA-Z0-9_]/g, '');
  
  return cleaned;
}
